<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain" v-if="loadSuccess">
      <div class="el-row">
        <div class="box">
          <el-col :span="24">
            <div class="header"><h3>系统配置</h3></div>

            <div class="formDiv">
              <el-form label-width="100px" :model="form" ref="formData">
                <el-form-item label="刊物名称" prop="publicationName">
                  <el-input maxlength="50" placeholder="" v-model="form.publicationName" style="width: 300px"></el-input>
                </el-form-item>

                <el-form-item label="主任编辑" prop="chiefEditor">
                  <el-input v-model="editor" placeholder="点击按钮选择人员" class="input-with-select" :readonly="true" style="width: 300px">
                    <el-input></el-input>
                    <el-button slot="append" icon="el-icon-search" @click="searchUser">选择</el-button>
                  </el-input>
                </el-form-item>

                <!--el-form-item label="预设审稿费" prop="reviewFee">
                  <el-input-number v-model="form.reviewFee" :precision="2" :step="5"></el-input-number>
                </!--el-form-item-->

                <el-form-item label="投稿须知" prop="instructionsForSubmission">
                  <TinymceEditor :editorData="form" :height="400" />
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" icon="remix-icon-account-pin-box-fill" @click="update">更新保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </div>
      </div>
    </div>

    <el-empty description="加载失败" v-if="!loadSuccess"></el-empty>

    <el-drawer title="选择主任编辑" :visible.sync="drawer" :direction="'rtl'" :size="600">
      <div style="padding: 20px">
        <SearchUser :single="true" :closeFun="closeDrawer" :yesFun="selectUser"></SearchUser>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import SearchUser from "@/components/SearchUser.vue"
import TinymceEditor from "@/components/TinymceEditor"
import settingApi from "@/api/setting"
export default {
  components: { PageHeader, TinymceEditor, SearchUser },
  data() {
    return {
      headLinks: [
        { path: "", title: "基础数据" },
        { path: "", title: "系统配置" },
      ],
      loadSuccess: null,
      drawer: false,
      editor: "",
      form: {
        chiefEditor: 0,
        content: "",
        publicationName: "",
        reviewFee: 0,
        instructionsForSubmission: "",
      },
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      settingApi.getSetting().then((res) => {
        if (res.code == 0) {
          this.form = res.data;
          if(res.data.chiefEditorUser!=null){
            this.editor = res.data.chiefEditorUser.loginName + "（" + res.data.chiefEditorUser.userName + "）"
          }
          this.form.content = this.form.instructionsForSubmission
          this.loadSuccess = true
        } else {
          this.loadSuccess = false
        }
      })
    },
    closeDrawer() {
      this.drawer = false
    },
    searchUser() {
      this.drawer = true
    },

    selectUser(rows) {
      this.editor = rows[0].loginName + "（" + rows[0].userName + "）"
      this.form.chiefEditor = rows[0].userId
      this.drawer = false
      //console.log(rows);
    },

    update() {
      this.form.instructionsForSubmission = this.form.content
      settingApi.updateSetting(this.form).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: "更新成功",
            type: "success",
          })
        } else {
          this.$notify.error({
            title: "错误",
            message: "更新失败" + res.msg,
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  margin: 30px;
  border: 1px solid #e2e2e2;
  padding: 15px 25px;
  height: 100%;

  .header {
    line-height: 44px;
  }
}
.box::after {
  content: "";
  display: block;
  height: 0;
  clear: both;
}

.formDiv {
  margin: 20px;
}
</style>
